export const environment = {
  production: false,
  version: '1.1.36',
  title: 'Optagestion',
  baseApiSysOpt: 'http://localhost:4200/api/optica',
};